import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    taskId: Number,
    taskUrl: String
  }

  connect() {
    this.orb = this.element.querySelector(".mj-focus-orb")
    if (this.orb && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.boundParallax = this.onScroll.bind(this)
      window.addEventListener("scroll", this.boundParallax, { passive: true })
    }
  }

  disconnect() {
    if (this.boundParallax) window.removeEventListener("scroll", this.boundParallax)
  }

  onScroll() {
    if (!this.orb) return
    const rect = this.element.getBoundingClientRect()
    if (rect.bottom < 0 || rect.top > window.innerHeight) return
    const offset = window.scrollY * 0.14
    this.orb.style.transform = `translate(${-offset * 0.3}px, ${offset}px)`
  }

  start(event) {
    event.preventDefault()
    if (!this.hasTaskUrlValue) return

    const tasksSection = document.querySelector(".mj-tasks-section")
    if (tasksSection) {
      tasksSection.scrollIntoView({ behavior: "smooth", block: "start" })
    }

    const frame = document.querySelector("turbo-frame#task_modal")
    if (frame) {
      frame.src = this.taskUrlValue
    } else {
      window.Turbo?.visit(this.taskUrlValue, { frame: "task_modal" })
    }

    if (this.hasTaskIdValue) {
      const row = document.querySelector(`[data-task-id="${this.taskIdValue}"]`)
      if (row) {
        row.classList.add("mj-task-row-flash")
        setTimeout(() => row.classList.remove("mj-task-row-flash"), 1400)
      }
    }
  }
}
